<template>
  <li class="header__nav-profile">
    <template v-if="isLoggedIn">
      <div>{{ user?.email }}</div>
      <ul>
        <slot></slot>
        <li>
          <button type="button" @click="logout()">
            {{ $t("user.logout") }}
          </button>
        </li>
      </ul>
    </template>
    <button v-else type="button" @click="openLoginModal()">
      {{ $t("user.loginRegister") }}
    </button>
  </li>
</template>

<script setup lang="ts">
import { isLoggedIn, user, openLoginModal, logout } from "./store";
</script>
